<template>
	<div :class="classes">
		<Block v-for="n in 4" :key="n" :pos="getPos(n)" ref="blocks" :active="true"/>
		<template v-if="active">
			<Block v-for="n in 4" :key="n" :pos="getPos(n, shadow)" ref="shadowBlocks" style="opacity:0.5"/>
		</template>
	</div>
</template>

<script>
import Block from './Block.vue'
import { POS } from '../static/POS.js'
import { SRS } from '../static/SRS.js'

const PIECE_TYPES = {
	i: 'i',
	o: 'o',
	t: 't',
	j: 'j',
	l: 'l',
	s: 's',
	z: 'z',
}
const pieceTypes = Object.keys(PIECE_TYPES)

export default {
	name: 'Piece',
	components: { Block },
	props: {
		hidden: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			name: 'piece',
			type: PIECE_TYPES.i,
			rotation: 1,
			x: 13,
			y: 3,
			shadow: 0,
			active: false,
		}
	},
	computed: {
		classes() {
			return [
				this.name,
				`${this.name}-t${this.type}--r${this.rotation}`,
				{ [`${this.name}--hidden`]: this.hidden },
			]
		},
	},
	methods: {
		getPos(n, _y = this.y, _x = this.x, _r = this.rotation) {
			const { x, y } = POS[this.type][_r - 1][n - 1]
			return {
				x: _x + x,
				y: _y + y,
			}
		},
		calcShadow() {
			for (let y = this.y; y <= 22; y++) {
				if (this.checkCollision(this.x, y, this.rotation)) {
					this.shadow = y - 1
					return
				}
			}
			this.shadow = 22
		},
		move(movement) {
			const r = (this.rotation + movement.r - 1) % 4 + 1
			let x = this.x + movement.x
			let y = this.y + movement.y
			if (this.checkCollision(x, y, r)) {
				if (movement.y > 0) {
					this.release()
				} else if (movement.r !== 0) {
					const pos = this.kick(movement.r)
					if (!pos) return false
					x += pos.x
					y += pos.y
				} else {
					return false
				}
			}
			this.x = x
			this.y = y
			this.rotation = r
			this.$nextTick(() => this.calcShadow())
		},
		kick(rotation) {
			const direction = rotation > 0 ? 'c' : 'cc'
			const r = (this.rotation + rotation - 1) % 4 + 1
			return SRS[this.type][this.rotation - 1][direction].find(pos => {
				const x = this.x + pos.x
				const y = this.y + pos.y
				return !this.checkCollision(x, y, r)
			})
		},
		drop() {
			this.y = this.shadow
			this.$nextTick(() => this.release())
		},
		tick() {
			this.move({ x: 0, y: 1, r: 0 })
		},
		activate() {
			this.x = 5
			this.y = 0
			this.active = true
			this.$nextTick(() => this.calcShadow())
		},
		hold() {
			this.active = false
			this.x = -3
			this.y = 3
			this.rotation = 1
		},
		release() {
			this.$root.$el.dispatchEvent(new CustomEvent('release', { detail: { blocks: this.$refs.blocks } }))
		},
		reset(existing) {
			this.active = false
			do {
				this.type = pieceTypes[Math.floor(Math.random() * pieceTypes.length)]
			} while (this.type === existing)
			this.x = 13
			this.y = 3
			this.rotation = 1
		},
		checkCollision(x, y, r) {
			for (let i = 0; i < this.$refs.blocks.length; i++) {
				const pos = this.getPos(i + 1, y, x, r)
				if (this.$refs.blocks[i].checkCollision(pos.x, pos.y)) {
					return true
				}
			}
			return false
		},
	},
	created() {
		this.type = pieceTypes[Math.floor(Math.random() * pieceTypes.length)]
	},
}
</script>

<style lang="scss">
.piece--hidden {
	display: none;
}
</style>
